'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var _formValidation = require('../../helpers/formValidation');

var _formValidation2 = _interopRequireDefault(_formValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = _formValidation2.default.name,
    lastName = _formValidation2.default.lastName,
    company = _formValidation2.default.company,
    email = _formValidation2.default.email,
    message = _formValidation2.default.message;


var validate = (0, _validation.createValidator)({
  firstName: name,
  lastName: lastName,
  company: company,
  email: email,
  enquiryMessage: message
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginContactForm/loginContactFormValidation.js
// module id = 2031
// module chunks = 1